// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Summary Section Styles */
.summary-section {
  padding: 0;
}

.summary-container {
  background-color: rgba(55, 65, 81, 0.3);
  border-radius: 0.75rem;
  padding: 1.5rem;
  color: white;
  line-height: 1.8;
}

/* Summary-specific styles */
.summary-h1 {
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(96, 165, 250, 0.3);
}

.summary-h2 {
  font-size: 1.25rem;
  font-weight: 600;
  color: white;
  margin: 1.5rem 0 0.75rem;
}

.summary-h3 {
  font-size: 1.125rem;
  font-weight: 500;
  color: white;
  margin: 1rem 0 0.5rem;
}

.summary-p {
  color: rgb(209, 213, 219);
  line-height: 1.625;
  margin-bottom: 1rem;
}

.summary-ul {
  margin: 0 0 1rem 1rem;
  list-style: none;
}

.summary-ol {
  margin: 0 0 1rem 1rem;
  list-style: decimal inside;
  color: rgb(209, 213, 219);
}

.summary-li {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  color: rgb(209, 213, 219);
  margin-bottom: 0.5rem;
}

.summary-li::before {
  content: "•";
  color: rgb(96, 165, 250);
  font-weight: bold;
  width: 1rem;
  text-align: center;
}

.summary-blockquote {
  border-left: 4px solid rgba(96, 165, 250, 0.5);
  background-color: rgba(96, 165, 250, 0.1);
  padding: 0.5rem 0.75rem;
  margin: 1rem 0;
  font-style: italic;
  color: rgb(209, 213, 219);
}

.summary-inline-code {
  background-color: rgba(55, 65, 81, 0.6);
  color: rgb(147, 197, 253);
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: ui-monospace, SFMono-Regular, monospace;
}

/* KaTeX Math Rendering Styles */
.katex {
  color: rgb(229, 231, 235) !important;
  font-size: 1.1em !important;
}

.katex .katex-html {
  color: rgb(229, 231, 235) !important;
}

/* Display (block) math styling */
.katex-display {
  margin: 1.5rem 0 !important;
  text-align: center !important;
  overflow-x: auto !important;
}

.katex-display .katex {
  display: inline-block !important;
  background-color: rgba(31, 41, 55, 0.6) !important;
  padding: 1rem 1.5rem !important;
  border-radius: 0.5rem !important;
  border: 1px solid rgba(75, 85, 99, 0.4) !important;
  color: white !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
}

/* Inline math styling */
.katex:not(.katex-display) {
  background-color: rgba(55, 65, 81, 0.7) !important;
  padding: 0.2rem 0.4rem !important;
  border-radius: 0.25rem !important;
  border: 1px solid rgba(75, 85, 99, 0.4) !important;
  margin: 0 0.1rem !important;
  color: rgb(147, 197, 253) !important;
}

/* KaTeX elements styling */
.katex .base {
  color: rgb(229, 231, 235) !important;
}

.katex .mord, 
.katex .mbin, 
.katex .mrel, 
.katex .mopen, 
.katex .mclose, 
.katex .mpunct,
.katex .mop {
  color: rgb(229, 231, 235) !important;
}

/* Special math symbols */
.katex .accent > .vlist-t > .vlist-r > .vlist > .vlist-elem {
  color: rgb(96, 165, 250) !important;
}

/* Fraction lines */
.katex .frac-line {
  border-bottom-color: rgb(156, 163, 175) !important;
  border-bottom-width: 1px !important;
}

/* Square root symbols */
.katex .sqrt > .vlist-t > .vlist-r > .vlist > .vlist-elem:first-child {
  border-color: rgb(156, 163, 175) !important;
}

/* Math operators like sum, integral */
.katex .op-symbol {
  color: rgb(96, 165, 250) !important;
}

/* Subscripts and superscripts */
.katex .msupsub {
  color: rgb(209, 213, 219) !important;
}

/* Greek letters and special symbols */
.katex .mathdefault {
  color: rgb(168, 85, 247) !important;
}

/* Matrix brackets */
.katex .delimsizing,
.katex .delim-size1,
.katex .delim-size2,
.katex .delim-size3,
.katex .delim-size4 {
  color: rgb(96, 165, 250) !important;
}

/* Error styling for malformed math */
.katex .katex-error {
  color: rgb(239, 68, 68) !important;
  background-color: rgba(239, 68, 68, 0.1) !important;
  border: 1px solid rgba(239, 68, 68, 0.3) !important;
}

/* Responsive design for mobile */
@media (max-width: 768px) {
  .summary-container {
    padding: 1rem;
  }
  
  .katex-display .katex {
    padding: 0.75rem 1rem !important;
    font-size: 0.9em !important;
  }
  
  .katex:not(.katex-display) {
    padding: 0.15rem 0.3rem !important;
    font-size: 0.9em !important;
  }
  
  .markdown-h1 {
    font-size: 1.25rem;
  }

  .markdown-h2 {
    font-size: 1.125rem;
  }

  .markdown-h3 {
    font-size: 1rem;
  }

  .markdown-paragraph {
    font-size: 0.9rem;
  }

  .markdown-table {
    font-size: 0.8rem;
  }
  
  .markdown-table__header,
  .markdown-table__cell {
    padding: 0.5rem;
  }
}

@media (max-width: 640px) {
  .summary-container {
    padding: 0.75rem;
    border-radius: 0.5rem;
  }
  
  .summary-h1 {
    font-size: 1.25rem;
    margin-bottom: 0.75rem;
  }
  
  .summary-h2 {
    font-size: 1.125rem;
    margin: 1rem 0 0.5rem;
  }
  
  .summary-h3 {
    font-size: 1rem;
    margin: 0.75rem 0 0.4rem;
  }
}

@media (max-width: 480px) {
  .summary-container {
    padding: 0.5rem;
    border-radius: 0.25rem;
  }
  
  .summary-h1 {
    font-size: 1.125rem;
  }
  
  .summary-h2 {
    font-size: 1rem;
  }
  
  .summary-h3 {
    font-size: 0.9rem;
  }
  
  .summary-p {
    font-size: 0.875rem;
    line-height: 1.5;
  }
}

@media (max-width: 380px) {
  .summary-container {
    padding: 0.4rem;
    border-radius: 0;
    background-color: rgba(55, 65, 81, 0.2);
  }
  
  .summary-h1 {
    font-size: 1rem;
  }
  
  .summary-h2 {
    font-size: 0.9rem;
  }
  
  .summary-h3 {
    font-size: 0.85rem;
  }
  
  .summary-p {
    font-size: 0.8rem;
  }
}

@media (max-width: 320px) {
  .summary-container {
    padding: 0.3rem;
    background-color: rgba(55, 65, 81, 0.1);
  }
}

/* Headings */
.markdown-h1 {
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(96, 165, 250, 0.3);
}

.markdown-h2 {
  font-size: 1.25rem;
  font-weight: 600;
  color: white;
  margin: 1.5rem 0 0.75rem;
}

.markdown-h3 {
  font-size: 1.125rem;
  font-weight: 500;
  color: white;
  margin: 1rem 0 0.5rem;
}

.markdown-h4 {
  font-size: 1rem;
  font-weight: 500;
  color: rgb(229, 231, 235);
  margin: 0.75rem 0 0.5rem;
}

.markdown-h5 {
  font-size: 0.875rem;
  font-weight: 500;
  color: rgb(209, 213, 219);
  margin: 0.75rem 0 0.5rem;
}

.markdown-h6 {
  font-size: 0.875rem;
  font-weight: 500;
  color: rgb(156, 163, 175);
  margin: 0.75rem 0 0.5rem;
}

/* Paragraphs */
.markdown-paragraph {
  color: rgb(209, 213, 219);
  line-height: 1.625;
  margin-bottom: 1rem;
}

/* Lists */
.markdown-list {
  margin: 0 0 1rem 1rem;
}

.markdown-list--unordered {
  list-style: none;
}

.markdown-list--ordered {
  list-style: decimal inside;
  color: rgb(209, 213, 219);
}

.markdown-list-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  color: rgb(209, 213, 219);
  margin-bottom: 0.5rem;
}

.markdown-list-item__bullet {
  width: 0.5rem;
  height: 0.5rem;
  background-color: rgb(96, 165, 250);
  border-radius: 9999px;
  margin-top: 0.5rem;
  flex-shrink: 0;
}

.markdown-list-item__content {
  flex: 1 1;
}

/* Links */
.markdown-link {
  color: rgb(96, 165, 250);
  text-decoration: underline;
  transition: color 0.15s ease;
}

.markdown-link:hover {
  color: rgb(147, 197, 253);
}

/* Emphasis */
.markdown-strong {
  font-weight: 600;
  color: white;
}

.markdown-emphasis {
  font-style: italic;
  color: rgb(229, 231, 235);
}

/* Code */
.markdown-code-block {
  margin: 1rem 0;
}

.markdown-code-block__content {
  border-radius: 0.5rem;
  font-size: 0.875rem;
}

.markdown-inline-code {
  background-color: rgba(55, 65, 81, 0.6);
  color: rgb(147, 197, 253);
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: ui-monospace, SFMono-Regular, monospace;
}

/* Blockquotes */
.markdown-blockquote {
  border-left: 4px solid rgba(96, 165, 250, 0.5);
  background-color: rgba(96, 165, 250, 0.1);
  padding: 0.5rem 0.75rem;
  margin: 1rem 0;
  font-style: italic;
  color: rgb(209, 213, 219);
}

/* Tables */
.markdown-table-wrapper {
  overflow-x: auto;
  margin: 1rem 0;
}

.markdown-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid rgb(75, 85, 99);
  border-radius: 0.5rem;
}

.markdown-table__header {
  border: 1px solid rgb(75, 85, 99);
  background-color: rgba(55, 65, 81, 0.5);
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: white;
}

.markdown-table__cell {
  border: 1px solid rgb(75, 85, 99);
  background-color: rgba(31, 41, 55, 0.3);
  padding: 1rem;
  color: rgb(209, 213, 219);
}

/* Divider */
.markdown-divider {
  border: none;
  border-top: 1px solid rgb(75, 85, 99);
  margin: 1.5rem 0;
}

/* No content message */
.no-content {
  text-align: center;
  padding: 3rem;
  color: rgb(156, 163, 175);
}

.no-content p {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
}

.no-content small {
  color: rgb(107, 114, 128);
  font-size: 0.875rem;
  display: block;
}

/* High Contrast Mode */
@media (prefers-contrast: high) {
  .summary-container {
    border: 2px solid white;
  }
  
  .markdown-link {
    text-decoration-thickness: 2px;
  }
  
  .markdown-blockquote {
    border-left-width: 6px;
  }
  
  .markdown-table {
    border-width: 2px;
  }
  
  .markdown-table__header,
  .markdown-table__cell {
    border-width: 2px;
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  .markdown-link {
    transition: none;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/VideoTabs/SummaryTab.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,yCAAyC;EACzC,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA,gCAAgC;AAChC;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,iCAAiC;AACjC;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,kDAAkD;EAClD,+BAA+B;EAC/B,gCAAgC;EAChC,kDAAkD;EAClD,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA,wBAAwB;AACxB;EACE,kDAAkD;EAClD,iCAAiC;EACjC,iCAAiC;EACjC,kDAAkD;EAClD,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA,2BAA2B;AAC3B;EACE,oCAAoC;AACtC;;AAEA;;;;;;;EAOE,oCAAoC;AACtC;;AAEA,yBAAyB;AACzB;EACE,mCAAmC;AACrC;;AAEA,mBAAmB;AACnB;EACE,kDAAkD;EAClD,mCAAmC;AACrC;;AAEA,wBAAwB;AACxB;EACE,2CAA2C;AAC7C;;AAEA,sCAAsC;AACtC;EACE,mCAAmC;AACrC;;AAEA,gCAAgC;AAChC;EACE,oCAAoC;AACtC;;AAEA,sCAAsC;AACtC;EACE,mCAAmC;AACrC;;AAEA,oBAAoB;AACpB;;;;;EAKE,mCAAmC;AACrC;;AAEA,qCAAqC;AACrC;EACE,kCAAkC;EAClC,mDAAmD;EACnD,mDAAmD;AACrD;;AAEA,iCAAiC;AACjC;EACE;IACE,aAAa;EACf;;EAEA;IACE,gCAAgC;IAChC,2BAA2B;EAC7B;;EAEA;IACE,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,uCAAuC;EACzC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,uCAAuC;EACzC;AACF;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mCAAmC;EACnC,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA,UAAU;AACV;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA,gBAAgB;AAChB;EACE,8CAA8C;EAC9C,yCAAyC;EACzC,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,aAAa;EACb,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Summary Section Styles */\n.summary-section {\n  padding: 0;\n}\n\n.summary-container {\n  background-color: rgba(55, 65, 81, 0.3);\n  border-radius: 0.75rem;\n  padding: 1.5rem;\n  color: white;\n  line-height: 1.8;\n}\n\n/* Summary-specific styles */\n.summary-h1 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: white;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid rgba(96, 165, 250, 0.3);\n}\n\n.summary-h2 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: white;\n  margin: 1.5rem 0 0.75rem;\n}\n\n.summary-h3 {\n  font-size: 1.125rem;\n  font-weight: 500;\n  color: white;\n  margin: 1rem 0 0.5rem;\n}\n\n.summary-p {\n  color: rgb(209, 213, 219);\n  line-height: 1.625;\n  margin-bottom: 1rem;\n}\n\n.summary-ul {\n  margin: 0 0 1rem 1rem;\n  list-style: none;\n}\n\n.summary-ol {\n  margin: 0 0 1rem 1rem;\n  list-style: decimal inside;\n  color: rgb(209, 213, 219);\n}\n\n.summary-li {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  color: rgb(209, 213, 219);\n  margin-bottom: 0.5rem;\n}\n\n.summary-li::before {\n  content: \"•\";\n  color: rgb(96, 165, 250);\n  font-weight: bold;\n  width: 1rem;\n  text-align: center;\n}\n\n.summary-blockquote {\n  border-left: 4px solid rgba(96, 165, 250, 0.5);\n  background-color: rgba(96, 165, 250, 0.1);\n  padding: 0.5rem 0.75rem;\n  margin: 1rem 0;\n  font-style: italic;\n  color: rgb(209, 213, 219);\n}\n\n.summary-inline-code {\n  background-color: rgba(55, 65, 81, 0.6);\n  color: rgb(147, 197, 253);\n  padding: 0.125rem 0.375rem;\n  border-radius: 0.25rem;\n  font-size: 0.875rem;\n  font-family: ui-monospace, SFMono-Regular, monospace;\n}\n\n/* KaTeX Math Rendering Styles */\n.katex {\n  color: rgb(229, 231, 235) !important;\n  font-size: 1.1em !important;\n}\n\n.katex .katex-html {\n  color: rgb(229, 231, 235) !important;\n}\n\n/* Display (block) math styling */\n.katex-display {\n  margin: 1.5rem 0 !important;\n  text-align: center !important;\n  overflow-x: auto !important;\n}\n\n.katex-display .katex {\n  display: inline-block !important;\n  background-color: rgba(31, 41, 55, 0.6) !important;\n  padding: 1rem 1.5rem !important;\n  border-radius: 0.5rem !important;\n  border: 1px solid rgba(75, 85, 99, 0.4) !important;\n  color: white !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;\n}\n\n/* Inline math styling */\n.katex:not(.katex-display) {\n  background-color: rgba(55, 65, 81, 0.7) !important;\n  padding: 0.2rem 0.4rem !important;\n  border-radius: 0.25rem !important;\n  border: 1px solid rgba(75, 85, 99, 0.4) !important;\n  margin: 0 0.1rem !important;\n  color: rgb(147, 197, 253) !important;\n}\n\n/* KaTeX elements styling */\n.katex .base {\n  color: rgb(229, 231, 235) !important;\n}\n\n.katex .mord, \n.katex .mbin, \n.katex .mrel, \n.katex .mopen, \n.katex .mclose, \n.katex .mpunct,\n.katex .mop {\n  color: rgb(229, 231, 235) !important;\n}\n\n/* Special math symbols */\n.katex .accent > .vlist-t > .vlist-r > .vlist > .vlist-elem {\n  color: rgb(96, 165, 250) !important;\n}\n\n/* Fraction lines */\n.katex .frac-line {\n  border-bottom-color: rgb(156, 163, 175) !important;\n  border-bottom-width: 1px !important;\n}\n\n/* Square root symbols */\n.katex .sqrt > .vlist-t > .vlist-r > .vlist > .vlist-elem:first-child {\n  border-color: rgb(156, 163, 175) !important;\n}\n\n/* Math operators like sum, integral */\n.katex .op-symbol {\n  color: rgb(96, 165, 250) !important;\n}\n\n/* Subscripts and superscripts */\n.katex .msupsub {\n  color: rgb(209, 213, 219) !important;\n}\n\n/* Greek letters and special symbols */\n.katex .mathdefault {\n  color: rgb(168, 85, 247) !important;\n}\n\n/* Matrix brackets */\n.katex .delimsizing,\n.katex .delim-size1,\n.katex .delim-size2,\n.katex .delim-size3,\n.katex .delim-size4 {\n  color: rgb(96, 165, 250) !important;\n}\n\n/* Error styling for malformed math */\n.katex .katex-error {\n  color: rgb(239, 68, 68) !important;\n  background-color: rgba(239, 68, 68, 0.1) !important;\n  border: 1px solid rgba(239, 68, 68, 0.3) !important;\n}\n\n/* Responsive design for mobile */\n@media (max-width: 768px) {\n  .summary-container {\n    padding: 1rem;\n  }\n  \n  .katex-display .katex {\n    padding: 0.75rem 1rem !important;\n    font-size: 0.9em !important;\n  }\n  \n  .katex:not(.katex-display) {\n    padding: 0.15rem 0.3rem !important;\n    font-size: 0.9em !important;\n  }\n  \n  .markdown-h1 {\n    font-size: 1.25rem;\n  }\n\n  .markdown-h2 {\n    font-size: 1.125rem;\n  }\n\n  .markdown-h3 {\n    font-size: 1rem;\n  }\n\n  .markdown-paragraph {\n    font-size: 0.9rem;\n  }\n\n  .markdown-table {\n    font-size: 0.8rem;\n  }\n  \n  .markdown-table__header,\n  .markdown-table__cell {\n    padding: 0.5rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .summary-container {\n    padding: 0.75rem;\n    border-radius: 0.5rem;\n  }\n  \n  .summary-h1 {\n    font-size: 1.25rem;\n    margin-bottom: 0.75rem;\n  }\n  \n  .summary-h2 {\n    font-size: 1.125rem;\n    margin: 1rem 0 0.5rem;\n  }\n  \n  .summary-h3 {\n    font-size: 1rem;\n    margin: 0.75rem 0 0.4rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .summary-container {\n    padding: 0.5rem;\n    border-radius: 0.25rem;\n  }\n  \n  .summary-h1 {\n    font-size: 1.125rem;\n  }\n  \n  .summary-h2 {\n    font-size: 1rem;\n  }\n  \n  .summary-h3 {\n    font-size: 0.9rem;\n  }\n  \n  .summary-p {\n    font-size: 0.875rem;\n    line-height: 1.5;\n  }\n}\n\n@media (max-width: 380px) {\n  .summary-container {\n    padding: 0.4rem;\n    border-radius: 0;\n    background-color: rgba(55, 65, 81, 0.2);\n  }\n  \n  .summary-h1 {\n    font-size: 1rem;\n  }\n  \n  .summary-h2 {\n    font-size: 0.9rem;\n  }\n  \n  .summary-h3 {\n    font-size: 0.85rem;\n  }\n  \n  .summary-p {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 320px) {\n  .summary-container {\n    padding: 0.3rem;\n    background-color: rgba(55, 65, 81, 0.1);\n  }\n}\n\n/* Headings */\n.markdown-h1 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: white;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid rgba(96, 165, 250, 0.3);\n}\n\n.markdown-h2 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: white;\n  margin: 1.5rem 0 0.75rem;\n}\n\n.markdown-h3 {\n  font-size: 1.125rem;\n  font-weight: 500;\n  color: white;\n  margin: 1rem 0 0.5rem;\n}\n\n.markdown-h4 {\n  font-size: 1rem;\n  font-weight: 500;\n  color: rgb(229, 231, 235);\n  margin: 0.75rem 0 0.5rem;\n}\n\n.markdown-h5 {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: rgb(209, 213, 219);\n  margin: 0.75rem 0 0.5rem;\n}\n\n.markdown-h6 {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: rgb(156, 163, 175);\n  margin: 0.75rem 0 0.5rem;\n}\n\n/* Paragraphs */\n.markdown-paragraph {\n  color: rgb(209, 213, 219);\n  line-height: 1.625;\n  margin-bottom: 1rem;\n}\n\n/* Lists */\n.markdown-list {\n  margin: 0 0 1rem 1rem;\n}\n\n.markdown-list--unordered {\n  list-style: none;\n}\n\n.markdown-list--ordered {\n  list-style: decimal inside;\n  color: rgb(209, 213, 219);\n}\n\n.markdown-list-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  color: rgb(209, 213, 219);\n  margin-bottom: 0.5rem;\n}\n\n.markdown-list-item__bullet {\n  width: 0.5rem;\n  height: 0.5rem;\n  background-color: rgb(96, 165, 250);\n  border-radius: 9999px;\n  margin-top: 0.5rem;\n  flex-shrink: 0;\n}\n\n.markdown-list-item__content {\n  flex: 1;\n}\n\n/* Links */\n.markdown-link {\n  color: rgb(96, 165, 250);\n  text-decoration: underline;\n  transition: color 0.15s ease;\n}\n\n.markdown-link:hover {\n  color: rgb(147, 197, 253);\n}\n\n/* Emphasis */\n.markdown-strong {\n  font-weight: 600;\n  color: white;\n}\n\n.markdown-emphasis {\n  font-style: italic;\n  color: rgb(229, 231, 235);\n}\n\n/* Code */\n.markdown-code-block {\n  margin: 1rem 0;\n}\n\n.markdown-code-block__content {\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n}\n\n.markdown-inline-code {\n  background-color: rgba(55, 65, 81, 0.6);\n  color: rgb(147, 197, 253);\n  padding: 0.125rem 0.375rem;\n  border-radius: 0.25rem;\n  font-size: 0.875rem;\n  font-family: ui-monospace, SFMono-Regular, monospace;\n}\n\n/* Blockquotes */\n.markdown-blockquote {\n  border-left: 4px solid rgba(96, 165, 250, 0.5);\n  background-color: rgba(96, 165, 250, 0.1);\n  padding: 0.5rem 0.75rem;\n  margin: 1rem 0;\n  font-style: italic;\n  color: rgb(209, 213, 219);\n}\n\n/* Tables */\n.markdown-table-wrapper {\n  overflow-x: auto;\n  margin: 1rem 0;\n}\n\n.markdown-table {\n  width: 100%;\n  border-collapse: collapse;\n  border: 1px solid rgb(75, 85, 99);\n  border-radius: 0.5rem;\n}\n\n.markdown-table__header {\n  border: 1px solid rgb(75, 85, 99);\n  background-color: rgba(55, 65, 81, 0.5);\n  padding: 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: white;\n}\n\n.markdown-table__cell {\n  border: 1px solid rgb(75, 85, 99);\n  background-color: rgba(31, 41, 55, 0.3);\n  padding: 1rem;\n  color: rgb(209, 213, 219);\n}\n\n/* Divider */\n.markdown-divider {\n  border: none;\n  border-top: 1px solid rgb(75, 85, 99);\n  margin: 1.5rem 0;\n}\n\n/* No content message */\n.no-content {\n  text-align: center;\n  padding: 3rem;\n  color: rgb(156, 163, 175);\n}\n\n.no-content p {\n  font-size: 1.1rem;\n  margin-bottom: 0.5rem;\n}\n\n.no-content small {\n  color: rgb(107, 114, 128);\n  font-size: 0.875rem;\n  display: block;\n}\n\n/* High Contrast Mode */\n@media (prefers-contrast: high) {\n  .summary-container {\n    border: 2px solid white;\n  }\n  \n  .markdown-link {\n    text-decoration-thickness: 2px;\n  }\n  \n  .markdown-blockquote {\n    border-left-width: 6px;\n  }\n  \n  .markdown-table {\n    border-width: 2px;\n  }\n  \n  .markdown-table__header,\n  .markdown-table__cell {\n    border-width: 2px;\n  }\n}\n\n/* Reduced Motion */\n@media (prefers-reduced-motion: reduce) {\n  .markdown-link {\n    transition: none;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
